import InboundEnhancedTableHead from './InboundEnhancedTableHead.view';

export default InboundEnhancedTableHead;
